import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { Eyebrow, Button } from "../components/Bits";
import EditableImage from "../components/EditableImage";
import DotCluster from "../components/DotCluster";
import { PROJECTS } from "../lib/content";

export default function Work() {
  return (
    <div>
      <PageHeader label="Our Work" titleLines={["Ambitious projects.", "Lasting impact."]}
        intro="From Cumbria's first under-18s venue to landmark festivals and major live events, our portfolio engages tens of thousands of people every year while creating volunteering, employment and partnership opportunities across the region." />

      <div>
        {PROJECTS.map((p, i) => {
          const flip = i % 2 === 1;
          return (
            <section key={p.id} data-testid={`work-project-${p.id}`} className={i % 2 ? "bg-[#070912] text-white border-y border-white/10" : "bg-white"}>
              <div className="container-x py-20 md:py-28">
                <div className={`grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}>
                  <Reveal>
                    <div className="relative">
                      <EditableImage id={`work.${p.id}.image`} src={p.image} alt={p.title} className="overflow-hidden rounded-[1.75rem] aspect-[4/3] block" imgClassName="h-full w-full object-cover" />
                      <span className={`absolute -top-8 ${flip ? "-right-4 lg:-right-8" : "-left-4 lg:-left-8"} font-display font-extrabold text-[6rem] lg:text-[8rem] leading-none ${i % 2 ? "text-white/[0.06]" : "text-nead-navy/[0.06]"}`}>{p.n}</span>
                    </div>
                  </Reveal>
                  <Reveal delay={0.1}>
                    <div className="flex items-center gap-3 flex-wrap">
                      <span className="inline-flex items-center rounded-full bg-nead-pink px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-white">{p.tag}</span>
                      {p.coming && (
                        <span className="inline-block rounded-full border border-nead-cyan/40 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-nead-cyan">Coming soon</span>
                      )}
                    </div>
                    <h2 className={`mt-6 font-display font-extrabold text-4xl sm:text-5xl tracking-tight leading-[1.03] ${i % 2 ? "text-white" : "text-nead-navy"}`}>{p.title}</h2>
                    {p.body.map((para, j) => (
                      <p key={j} className={`mt-5 leading-relaxed ${i % 2 ? "text-white/60" : "text-nead-navy/65"}`}>{para}</p>
                    ))}
                    {p.id === "events-development" && (
                      <div className="mt-7 flex flex-wrap gap-2">
                        {["Event management", "Volunteer coordination", "Marketing & comms", "Sponsorship", "Funding support", "Operational planning"].map((s) => (
                          <span key={s} className={`rounded-full px-4 py-1.5 text-sm ${i % 2 ? "border border-white/15 text-white/70" : "border border-black/10 text-nead-navy/70"}`}>{s}</span>
                        ))}
                      </div>
                    )}
                    {p.link && (
                      <div className="mt-8"><Button to={p.link} variant={i % 2 ? "pink" : "pink"} testId={`work-story-${p.id}`}>{p.coming ? "Find out more" : "Read the story"}</Button></div>
                    )}
                  </Reveal>
                </div>
              </div>
            </section>
          );
        })}
      </div>

      {/* CTA */}
      <section className="bg-white">
        <div className="container-x py-24 md:py-32">
          <div className="relative overflow-hidden rounded-[2rem] bg-nead-ink text-white p-10 md:p-20 text-center">
            <DotCluster className="absolute -top-8 -right-8 h-72 w-72 opacity-70" count={50} />
            <div className="absolute left-1/4 top-0 h-72 w-72 glow-pink pointer-events-none" />
            <div className="relative">
              <Reveal>
                <Eyebrow className="text-nead-cyan justify-center">Work with us</Eyebrow>
                <h2 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl mx-auto leading-[1.03]">
                  Got a project, event or club we could support?
                </h2>
                <p className="mt-6 text-white/60 max-w-xl mx-auto text-lg">
                  Whether you want to partner, sponsor, volunteer or just share an idea, we would love to hear from you. Head to Get Involved to start the conversation.
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-3">
                  <Button to="/partners" variant="pink" testId="work-partner-cta">Partner with us</Button>
                  <Button to="/get-involved" variant="outline-light" testId="work-volunteer-cta">Get involved</Button>
                </div>

                <div className="mt-14 flex items-center justify-center">
                  <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-4 text-left" data-testid="work-contact-rocco">
                    <div className="h-14 w-14 flex-none overflow-hidden rounded-full ring-2 ring-white/15">
                      <img src="/team/rocco.jpg" alt="Rocco Boyd" className="h-full w-full object-cover object-top" />
                    </div>
                    <div>
                      <div className="font-display font-bold text-white">Rocco Boyd</div>
                      <div className="text-sm text-white/55">Co-Chair &amp; Projects Manager</div>
                      <a href="mailto:rocco.boyd@nead.uk" className="text-sm font-medium text-nead-cyan hover:text-white transition-colors" data-testid="work-contact-rocco-email">rocco.boyd@nead.uk</a>
                    </div>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
